import React, { FC } from 'react';

import * as ST from './styled';

export interface IDotsProps {
    goToSlide: (i: number) => void,
    slideCount: number,
    currentSlide: number,
    autoplayInterval: number,
    autoplay: boolean,
    customDotsStyles?: ST.ICustomDotsStyles,
}

const DefaultDots: FC<IDotsProps> = ({
    goToSlide,
    slideCount,
    currentSlide,
    autoplayInterval,
    autoplay,
    customDotsStyles,
}) => {
    return (
        <ST.DotsContainer customStyles={customDotsStyles}>
            {Array(slideCount).fill(null).map((_, index) => (
                <ST.DotContainer
                    key={index}
                    active={index === currentSlide}
                    onClick={() => goToSlide(index)}
                    customStyles={customDotsStyles}
                >
                    <ST.Dot
                        active={index === currentSlide}
                        customStyles={customDotsStyles}
                    />
                    <ST.ActiveLine
                        active={index === currentSlide}
                        time={autoplay ? autoplayInterval / 1000 : 0}
                        customStyles={customDotsStyles}
                    />
                </ST.DotContainer>
            ))}
        </ST.DotsContainer>
    );
};

export default DefaultDots;
